(function () {
  // Attribute qualifier is required: Shopify's own OS 2.0 wrapper for this
  // section reuses the exact same class as a substring ("shopify-section
  // shopify-section--main-customers-addresses"), and querySelector returns
  // the first match in document order — that outer wrapper, not this file's
  // own inner <section> that actually carries data-api-ready/data-section-id.
  // Without this qualifier, root silently resolves to the wrong element and
  // every data-* read below returns undefined.
  var root = document.querySelector('.shopify-section--main-customers-addresses[data-api-ready]');
  if (!root) return;

  // A reload always lands on the list view, so take manual control of
  // scroll restoration rather than resuming wherever the form scrolled to.
  if (window.history && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);

  var loadingView = root.querySelector('[data-addresses-loading]');
  var errorView    = root.querySelector('[data-addresses-error]');
  var errorMsg     = root.querySelector('[data-addresses-error-message]');
  var listView     = root.querySelector('[data-addresses-list-view]');
  var formView     = root.querySelector('[data-address-form-view]');
  var listEl       = root.querySelector('[data-addresses-list]');
  var form         = root.querySelector('[data-address-form]');
  var formTitle    = root.querySelector('[data-address-form-title]');
  var formSubmit   = root.querySelector('[data-address-form-submit]');
  var formError    = root.querySelector('[data-address-form-error]');

  var apiReady        = root.dataset.apiReady === 'true';
  var apiBaseUrl      = root.dataset.apiBaseUrl;
  var customerId      = root.dataset.customerId;
  var timestamp       = root.dataset.apiTimestamp;
  var signature       = root.dataset.apiSignature;
  var noAddressesText = root.dataset.noAddressesText;

  var addressesById = {};
  var formMode = 'create'; // 'create' | 'update'
  var editingAddressId = null;
  var pendingScrollToTop = false;
  var initialUrlSyncDone = false;

  function headerOffset() {
    return window.innerWidth >= 768 ? 100 : 93;
  }

  function scrollSectionToTop(smooth) {
    var targetY = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(targetY, 0), behavior: smooth ? 'smooth' : 'auto' });
  }

  function scrollFieldIntoView(el) {
    var targetY = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
    window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
  }

  function showState(state) {
    loadingView.hidden = state !== 'loading';
    errorView.hidden    = state !== 'error';
    listView.hidden     = state !== 'list';
    formView.hidden      = state !== 'form';
  }

  function showError(message) {
    errorMsg.textContent = message;
    showState('error');
  }

  function getAddressParamFromUrl() {
    return new URLSearchParams(window.location.search).get('address');
  }

  function setAddressInUrl(value, push) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set('address', value);
    else url.searchParams.delete('address');
    history[push ? 'pushState' : 'replaceState']({}, '', url.toString());
  }

  function syncFormFromUrl() {
    var param = getAddressParamFromUrl();
    if (param === 'new') {
      openAddForm();
    } else if (param && addressesById[String(param)]) {
      openEditForm(param);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function addressLines(address) {
    var name = [address.first_name, address.last_name].filter(Boolean).join(' ');
    var lines = [
      name,
      address.company,
      address.address1,
      address.address2,
      [address.zip, address.city, address.province_code || address.province].filter(Boolean).join(' '),
      address.country,
      address.phone,
    ].filter(Boolean);
    return lines.map(escapeHtml).join('<br>');
  }

  function renderAddressCard(address, index) {
    var card = document.createElement('div');
    card.className = 'customers-address-card';
    card.dataset.addressId = address.id;

    var tagHtml = address.default
      ? '<p class="customers-address-card__tag">Default Address</p>'
      : '<p class="customers-address-card__tag customers-address-card__tag--secondary">Address ' + (index + 1) + '</p>';

    var deleteBtnHtml = address.default
      ? ''
      : '<button type="button" class="customers-link customers-link--danger" data-address-delete data-address-id="' + address.id + '">Delete</button>';

    card.innerHTML =
      tagHtml +
      '<address class="customers-address-card__body">' + addressLines(address) + '</address>' +
      '<div class="customers-address-card__actions">' +
        '<button type="button" class="customers-link" data-address-edit-open data-address-id="' + address.id + '">Edit</button>' +
        deleteBtnHtml +
      '</div>';
    return card;
  }

  function renderList() {
    listEl.innerHTML = '';
    var addresses = Object.values(addressesById).sort(function (a, b) {
      if (a.default) return -1;
      if (b.default) return 1;
      return 0;
    });
    addresses.forEach(function (address, index) {
      listEl.appendChild(renderAddressCard(address, index));
    });
  }

  function resetForm() {
    form.reset();
    formError.hidden = true;
    formError.textContent = '';
    form.querySelectorAll('.customers-field__input--error').forEach(function (input) {
      input.classList.remove('customers-field__input--error');
    });
  }

  function openAddForm() {
    resetForm();
    formMode = 'create';
    editingAddressId = null;
    formTitle.textContent = 'Add Address';
    formSubmit.textContent = 'Add Address';
    showState('form');
    scrollSectionToTop(true);
  }

  function openEditForm(addressId) {
    var address = addressesById[String(addressId)];
    if (!address) return;
    resetForm();
    formMode = 'update';
    editingAddressId = addressId;
    formTitle.textContent = 'Edit Address';
    formSubmit.textContent = 'Update Address';

    form.querySelectorAll('[data-field]').forEach(function (input) {
      var field = input.dataset.field;
      if (field === 'default') {
        input.checked = !!address.default;
        input.disabled = !!address.default;
      } else {
        input.value = address[field] || '';
      }
    });

    showState('form');
    scrollSectionToTop(true);
  }

  function authPayload() {
    return { customerId: customerId, timestamp: timestamp, signature: signature };
  }

  function apiPost(path, body) {
    return fetch(apiBaseUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    });
  }

  // Shared with main-customers-account.liquid's /account cache — same key,
  // so switching Orders/Addresses tabs doesn't refetch every time.
  var ACCOUNT_CACHE_KEY = 'kp_account_cache';
  var ACCOUNT_CACHE_TTL = 60000;
  function readAccountCache() {
    try {
      var raw = sessionStorage.getItem(ACCOUNT_CACHE_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached.at > ACCOUNT_CACHE_TTL) return null;
      return cached.data;
    } catch (e) { return null; }
  }
  function writeAccountCache(data) {
    try { sessionStorage.setItem(ACCOUNT_CACHE_KEY, JSON.stringify({ at: Date.now(), data: data })); }
    catch (e) { /* sessionStorage unavailable or full — fall through, just skip caching */ }
  }
  function clearAccountCache() {
    try { sessionStorage.removeItem(ACCOUNT_CACHE_KEY); }
    catch (e) { /* nothing to clean up */ }
  }

  function renderAddresses(data) {
    var addresses = data.addresses || [];
    addressesById = {};
    addresses.forEach(function (a) { addressesById[String(a.id)] = a; });

    if (addresses.length === 0) {
      errorMsg.textContent = noAddressesText;
      showState('error');
      return;
    }
    renderList();

    if (!pendingScrollToTop) {
      showState('list');
      if (!initialUrlSyncDone) {
        initialUrlSyncDone = true;
        syncFormFromUrl();
      }
      return;
    }
    pendingScrollToTop = false;
    setAddressInUrl(null, true);

    // Scroll to top behind the still-visible loading overlay before revealing
    // the list, so the loader never disappears before the page has settled.
    errorView.hidden = true;
    formView.hidden = true;
    listView.hidden = false;
    scrollSectionToTop(false);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        loadingView.hidden = true;
      });
    });
  }

  function fetchAddresses() {
    var cached = readAccountCache();
    if (cached) {
      renderAddresses(cached);
      return;
    }

    showState('loading');
    apiPost('/account', authPayload())
      .then(function (result) {
        if (!result.ok) {
          showError('Could not load your addresses right now. Please refresh the page and try again.');
          return;
        }
        writeAccountCache(result.data);
        renderAddresses(result.data);
      })
      .catch(function () {
        showError('Could not load your addresses right now. Please check your connection and try again.');
      });
  }

  function fieldValues() {
    var values = {};
    form.querySelectorAll('[data-field]').forEach(function (input) {
      if (input.dataset.field === 'default') return;
      values[input.dataset.field] = input.value.trim();
    });
    return values;
  }

  var FIELD_LABELS = {
    first_name: 'First Name',
    last_name: 'Last Name',
    address1: 'Address',
    address2: 'Apartment, suite, etc.',
    zip: 'Zip/Postal Code',
    city: 'City',
    country: 'Country',
    province: 'State/Province',
    phone: 'Phone',
  };

  // Letters (plus spaces/apostrophes/hyphens) only, with at least one letter
  // required so symbol-only input like "'''" or "--" doesn't slip through.
  // Matches the live character-stripping on first/last name inputs.
  var NAME_PATTERN = /^(?=.*[A-Za-z])[A-Za-z\s'-]+$/;
  // Same as NAME_PATTERN but also allows periods, to match the live
  // character-stripping on city/country/province inputs (e.g. "St. Louis").
  var PLACE_PATTERN = /^(?=.*[A-Za-z])[A-Za-z\s.'-]+$/;
  // Indian PIN code: 6 digits, first digit can't be 0.
  var ZIP_PATTERN = /^[1-9]\d{5}$/;
  // Requires at least one letter or digit so symbol-only input like "---"
  // doesn't pass as a street address.
  var ADDRESS_PATTERN = /[A-Za-z0-9]/;
  // Indian mobile number, optionally prefixed with +91/91 — same pattern
  // used for phone validation in sections/contact.liquid.
  var PHONE_PATTERN = /^(\+91[-\s]?)?[0]?(91)?[6789]\d{9}$/;

  var FIELD_VALIDATORS = {
    first_name: function (value) { return NAME_PATTERN.test(value) ? null : 'must contain letters only'; },
    last_name: function (value) { return NAME_PATTERN.test(value) ? null : 'must contain letters only'; },
    address1: function (value) { return ADDRESS_PATTERN.test(value) ? null : 'must contain at least one letter or number'; },
    address2: function (value) { return ADDRESS_PATTERN.test(value) ? null : 'must contain at least one letter or number'; },
    city: function (value) { return PLACE_PATTERN.test(value) ? null : 'must contain letters only'; },
    country: function (value) { return PLACE_PATTERN.test(value) ? null : 'must contain letters only'; },
    province: function (value) { return PLACE_PATTERN.test(value) ? null : 'must contain letters only'; },
    zip: function (value) { return ZIP_PATTERN.test(value) ? null : 'must be a valid 6-digit PIN code'; },
    phone: function (value) {
      if (value === '') return null; // optional field
      return PHONE_PATTERN.test(value) ? null : 'must be a valid 10-digit phone number';
    },
  };

  function validateField(input) {
    var field = input.dataset.field;
    var value = input.value.trim();
    var isRequired = input.hasAttribute('required');
    var error = null;

    if (isRequired && value === '') {
      error = 'is required';
    } else if (value !== '' || isRequired) {
      var validator = FIELD_VALIDATORS[field];
      if (validator) error = validator(value);
    }

    input.classList.toggle('customers-field__input--error', !!error);
    return error ? { input: input, label: FIELD_LABELS[field] || field, message: error } : null;
  }

  function validateAllFields() {
    var errors = [];
    form.querySelectorAll('[data-field]').forEach(function (input) {
      if (input.dataset.field === 'default') return;
      var error = validateField(input);
      if (error) errors.push(error);
    });
    return errors;
  }

  form.querySelectorAll('[data-field]').forEach(function (input) {
    if (input.dataset.field === 'default') return;
    input.addEventListener('input', function () {
      validateField(input);
    });
  });

  function showFormErrors(fields) {
    var messages = Object.keys(fields || {}).map(function (key) {
      return key + ': ' + fields[key];
    });
    formError.textContent = messages.length ? messages.join(' — ') : 'Something went wrong. Please check your details and try again.';
    formError.hidden = false;
  }

  function stopSubmitLoading() {
    formSubmit.disabled = false;
    formSubmit.classList.remove('is-loading');
    formSubmit.removeAttribute('aria-busy');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    formError.hidden = true;

    var errors = validateAllFields();
    if (errors.length) {
      formError.textContent = errors.map(function (e) { return e.label + ' ' + e.message; }).join('; ');
      formError.hidden = false;
      var firstErrorField = errors[0].input.closest('.customers-field') || errors[0].input;
      scrollFieldIntoView(firstErrorField);
      errors[0].input.focus({ preventScroll: true });
      return;
    }

    formSubmit.disabled = true;
    formSubmit.classList.add('is-loading');
    formSubmit.setAttribute('aria-busy', 'true');

    var values = fieldValues();
    var wantsDefault = form.querySelector('[data-field="default"]').checked;

    var request = formMode === 'create'
      ? apiPost('/addresses/create', Object.assign(authPayload(), values))
      : apiPost('/addresses/' + editingAddressId + '/update', Object.assign(authPayload(), values));

    request
      .then(function (result) {
        if (!result.ok) {
          stopSubmitLoading();
          if (result.status === 422 && result.data.fields) {
            showFormErrors(result.data.fields);
          } else if (result.status === 401 || (result.data && result.data.error === 'signature_expired')) {
            // The signature is stamped once at render and expires after 5 minutes —
            // only a page reload gets a fresh one.
            formError.textContent = 'Your session has timed out. Refreshing the page to continue…';
            formError.hidden = false;
            setTimeout(function () { window.location.reload(); }, 1500);
          } else {
            showFormErrors({});
          }
          return;
        }

        var address = result.data.address;
        addressesById[String(address.id)] = address;
        pendingScrollToTop = true;

        var alreadyDefault = address.default;
        var setDefaultPromise = (wantsDefault && !alreadyDefault)
          ? apiPost('/addresses/' + address.id + '/set-default', authPayload())
          : Promise.resolve(null);

        setDefaultPromise.then(function () {
          stopSubmitLoading();
          clearAccountCache();
          fetchAddresses();
        });
      })
      .catch(function () {
        stopSubmitLoading();
        showFormErrors({});
      });
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-address-add-open]')) {
      openAddForm();
      setAddressInUrl('new', true);
      return;
    }
    var editBtn = e.target.closest('[data-address-edit-open]');
    if (editBtn) {
      openEditForm(editBtn.dataset.addressId);
      setAddressInUrl(editBtn.dataset.addressId, true);
      return;
    }
    if (e.target.closest('[data-address-form-close]')) {
      showState('list');
      scrollSectionToTop(true);
      setAddressInUrl(null, true);
      return;
    }
    var deleteBtn = e.target.closest('[data-address-delete]');
    if (deleteBtn) {
      var addressId = deleteBtn.dataset.addressId;
      if (!window.confirm('Delete this address? This cannot be undone.')) return;

      deleteBtn.disabled = true;
      apiPost('/addresses/' + addressId + '/delete', authPayload())
        .then(function (result) {
          if (!result.ok) {
            deleteBtn.disabled = false;
            if (result.data && result.data.error === 'cannot_delete_only_address') {
              window.alert('You cannot delete your only saved address.');
            } else if (result.data && result.data.error === 'cannot_delete_default_address') {
              window.alert('The default address cannot be deleted. Set another address as default first, or edit this one instead.');
            } else {
              window.alert('Could not delete this address right now. Please try again.');
            }
            return;
          }
          delete addressesById[String(addressId)];
          clearAccountCache();
          renderList();
        })
        .catch(function () {
          deleteBtn.disabled = false;
          window.alert('Could not delete this address right now. Please try again.');
        });
    }
  });

  window.addEventListener('popstate', function () {
    var param = getAddressParamFromUrl();
    if (param === 'new') {
      openAddForm();
    } else if (param && addressesById[String(param)]) {
      openEditForm(param);
    } else {
      showState('list');
    }
  });

  if (!apiReady) {
    showError('Addresses are unavailable right now. Please make sure you are logged in and try again.');
    return;
  }

  fetchAddresses();
})();
